import _ from 'lodash';
import React from 'react';

import LazyImage from 'webshop/js/lazyimage';
import ProductHelpers from 'webshop/js/product-helpers';
import ProductRowMixin from 'webshop/js/product-row-mixin';

var AccessoryList = React.createClass({
    findCartCount: function(id) {
        var count = 0;
        if (!this.props.cartData) {
            return count;
        }
        var cartRow = _.findWhere(this.props.cartData.rows, {product: id});
        if (cartRow) {
            count = cartRow.count;
        }
        return count;
    },
    createRow: function (product, idx) {
        var cartCount = this.findCartCount(product.id);
        return <AccessoryListBox {...product} key={product.id} initial_count={4} cart_count={cartCount} position={idx} />;
    },
    render: function() {
        return <div>{this.props.products && this.props.products.map(this.createRow)}</div>;
    }
});

var AccessoryListBox = React.createClass({
    mixins: [ProductRowMixin],
    render: function () {
        var className,
            deliveryTime,
            countAvailable = this.props.stock_total - this.props.cart_count;

        if (this.props.delivery_time) {
          deliveryTime = <div className="delivery-time"><span>Toimitusaika&nbsp;{this.props.delivery_time}</span></div>;
          countAvailable = 1000;
        }

        const hasImg = !this.props.thumbnail,
              imgSrc = hasImg ? '/static/nettivanne/webshop/img/rengas.svg' : this.props.thumbnail,
              imgClass = !hasImg ? '' : 'no-pic';
        return (
            <div className="product-box accessory">
              <div className="left-container">
                  <div className="img">
                      <a href={this.props.url} onClick={this.handleProductClick}>
                          <LazyImage className={imgClass}
                               alt={this.props.brand + " " + this.props.model + " tuotekuva "}
                               src={imgSrc} />
                        {this.props.near_top && <div className="highlight-product"></div>}
                      </a>
                  </div>
                  <div className="product-name">
                      <a href={this.props.url} onClick={this.handleProductClick}>
                          <div className="brand">{this.props.brand}</div>
                          <div className="model">{this.props.model}{" "}{this.props.title_extra}</div>
                      </a>
                      <div className="details details-mobile">
                      </div>
                      {deliveryTime}
                  </div>
              </div>
              <div className="tire-size">
                  <ProductHelpers.ItemCountControl count={this.state.count}
                                                   unitPrice={this.props.unit_price}
                                                   interval={1}
                                                   max={countAvailable}
                                                   onChange={this.handleCountChange} />
              </div>
              {this.renderAddToCart()}
            </div>
        );
    },
    handleProductClick: function(e) {
        e.preventDefault();
        const urlTarget = this.props.url;
        dataLayer.push({
            'event': 'ecomProductClick',
            'ecommerce': {
              'click': {
                'actionField': {'list': 'Search Results'},
                'products': [{
                  // Name or ID is required.
                  'name': this.props.brand + ' ' + this.props.model + ' ' + this.props.title_extra,
                  'id': this.props.id,
                  'price': this.props.unit_price,
                  'brand': this.props.brand,
                  'category': 'Tarvikkeet',
                  'position': this.props.position,
                 }]
               }
             },
             'eventCallback': function() {
               document.location = urlTarget;
             }
        });
        document.location = urlTarget;
    }
});

export default AccessoryList;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/accessory-list.js
 **/